<app-inbox [aula]='aula' [id_usuario]='id_usuario' [id_centro]='id_centro'></app-inbox>
